import { ReactComponent as Gift } from "assets/icons/coming-soon.svg";
import { ReactComponent as Speaker } from "assets/icons/speaker.svg";
import { ReactComponent as Camera } from "assets/icons/camera.svg";
import { ReactComponent as Eyes } from "assets/icons/eyes.svg";

import { uploadFeatures } from "helpers/constants";

interface Props {
  type?: "gift" | "speaker" | "camera" | "eyes";
  title?: string;
  des?: string;
}
export const ComingSoon = ({
  type = "gift",
  title = "Coming soon!",
  des,
}: Props) => {
  return (
    <div className="p-4">
      <div className="flex flex-col justify-center items-center gap-4 py-6">
        {type === "gift" ? (
          <Gift className="w-24" />
        ) : type === "camera" ? (
          <Camera className="w-24" />
        ) : type === "speaker" ? (
          <Speaker className="w-24" />
        ) : (
          <Eyes className="w-24" />
        )}
        <div className="gap-2 flex flex-col justify-center items-center">
          {title && <div className="text-xl text-center">{title}</div>}
          {des && (
            <div className="text-sm text-center text-slate-300 ">{des}</div>
          )}
        </div>
        {type === "camera" ? (
          <div className="flex items-center justify-between gap-2 w-full ">
            {uploadFeatures.map((el) => (
              <div
                key={el.name}
                className="border-2 border-gray-800 py-4 rounded-xl flex-1 flex flex-col items-center justify-center gap-3"
              >
                <el.icon className="w-6" />
                <span className="text-sm text-slate-300">{el.name}</span>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};
